import {
  FlowUpdateCdtSource,
  PnlDecision,
  ProductToInsert,
  SwapFacingsMode,
} from "@CommonApi/merchflow/_merchflowId_/flow-update";
import { FlowUpdateProduct } from "@CommonApi/merchflow/_merchflowId_/flow-update/products";

export type MerchflowReviewUpdateStep =
  | "STEP_1_VIOLATIONS"
  | "STEP_2_STORE_SELECTION"
  | "STEP_3_PRODUCT_REVIEW"
  | "STEP_3A_SWAP_PRODUCTS"
  | "STEP_3B_REMOVE_PRODUCTS"
  | "STEP_3C_ADD_PRODUCTS"
  | "STEP_4_PLANOGRAM_RULES";

export type ProductUpdates = (ProductUpdateSwap | ProductUpdateRemove | ProductUpdateAdd)[];

/**
 * Lives on the wizard rather than on the rules step: the step unmounts on every
 * navigation, and this selection decides which CDT the Update API run uses.
 */
export interface CdtSelection {
  source: FlowUpdateCdtSource;
  preserveExistingPogCdt: boolean;
}

export const DEFAULT_CDT_SELECTION: CdtSelection = {
  source: "POG_SNAPSHOT",
  preserveExistingPogCdt: false,
};

export interface ProductUpdateSwap {
  type: "swap";
  remove: FlowUpdateProduct;
  add: FlowUpdateProduct[];
  pnlDecision: PnlDecision;
  storeCodes: string[];
  canSqueezeSwapTo: boolean;
  swapFacingsMode: SwapFacingsMode;
}

export interface ProductUpdateRemove {
  type: "remove";
  product: FlowUpdateProduct;
  pnlDecision: PnlDecision;
  storeCodes: string[];
}

export interface ProductUpdateAdd {
  type: "add";
  productToAdd: FlowUpdateProduct;
  adjacentPosition: NonNullable<ProductToInsert["adjacentProduct"]>["placeTo"] | null;
  adjacentProduct: FlowUpdateProduct | null;
  facings: string;
  reducibleProduct: FlowUpdateProduct | null;
  fitStrategy: ProductToInsert["fitStrategy"];
  pnlDecision: PnlDecision;
  storeCodes: string[];
  canBeSqueezed: boolean;
}
